export var SECOND = 1000;
export var MINUTE = SECOND * 60;
export var HOUR = MINUTE * 60;
export var DAY = HOUR * 24;
export var addMinutes = function (date, minutes) {
    return new Date(new Date(date).getTime() + minutes * MINUTE).toISOString();
};
export var calculateTimeLeft = function (timestamp) {
    var difference = +new Date(timestamp) - +new Date();
    return difference > 0 ? difference : 0;
};
export var formatTimeLeft = function (timeLeft, showHours) {
    if (showHours === void 0) { showHours = true; }
    var hours = String(Math.floor(timeLeft / HOUR));
    var minutes = String(Math.floor((timeLeft / MINUTE) % 60));
    var seconds = String(Math.floor((timeLeft / SECOND) % 60));
    return "".concat(showHours ? "".concat(hours.padStart(2, '0'), ":") : '').concat(minutes.padStart(2, '0'), ":").concat(seconds.padStart(2, '0'));
};
//# sourceMappingURL=time.js.map